/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from '@module-logger/mbp';
import MenuItem from '@material-ui/core/MenuItem';
import * as attributionHelpers from '../../../helpers/attribution/attributionHelpers';
/**
 * Redirects the user to the shipping page
 * @param {string} url
 * @param {*} location current location
 * @param {*} convId conversation Id
 * @param {*} history history object
 * @param {*} callUpdateProfileEmailId Function to update profile email
 */
export const redirectToShippingPage = (url, location, convId, history, callUpdateProfileEmailId) => {
    try {
        const formattedUrl = new URL(url);
        const searchParams = new URLSearchParams(formattedUrl?.search).toString();
        if (searchParams?.includes('refId')) {
            attributionHelpers.processAttribution({
                location,
                attributionURL: formattedUrl,
            }, `/checkout/express${formattedUrl.search}`);
            history.push(`/checkout/express${formattedUrl.search}`);
            const aigoAttributionObj = {
                convId,
                chatEnded: true,
                endDate: new Date(),
                isCurrentlyChatting: false,
            };
            const attrData = attributionHelpers.getAttributionDataFromChatWidget() || aigoAttributionObj;
            attrData.isFromAigo = true;
            attributionHelpers.storeAttributionDataFromChatWidget(attrData);
            const queryParams = Object.fromEntries(new URLSearchParams(formattedUrl.search));
            const customerEmail = queryParams?.bEmail;
            if (customerEmail && formattedUrl?.search?.includes('bEmail')) {
                callUpdateProfileEmailId(customerEmail);
            }
            mbpLogger.logInfo({
                appName: process.env.npm_package_name,
                function: 'redirectToShippingPage',
                message: `WebchatV2: Redirect to checkout - CONVID: ${convId} - REFID: ${formattedUrl?.search}`,
            });
        }
    } catch (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            errorMessage: error,
            message: `WebchatV2: failed to construct url: - ERROR: ${error} - CONVID: ${convId}`,
        });
    }
};
/**
 * Get address suggestions
 * @param {*} addressList list of addresses
 * @param {*} classList classes
 * @param {*} onClick event triggered when clicking an address
 * @param {*} message current message on chat input
 * @param {*} seed
 * @returns address suggestions
 */
export const getSuggestions = (addressList, classList, onClick, message, seed) => {
    if (addressList?.totalMatches !== 0) {
        return addressList?.results?.map((address) => (
            <MenuItem
                key={seed(address.suggestion)}
                onClick={() => onClick(address)}
                className={classList.addressList}
            >
                {address.suggestion}
            </MenuItem>
        ));
    }

    if (addressList?.totalMatches === 0 && message && message?.length > 1) {
        return (
            <MenuItem
                key="No_Match_Found"
                className={classList.addressList}
                style={{ borderBottom: 'none' }}
            >
                No address match found
            </MenuItem>
        );
    }
    return null;
};

/**
     * returns the hostname for provided url
     * @param {*} url
     */
export const getHostname = (url) => {
    // use URL constructor and return hostname
    try {
        const host = new URL(url).hostname;
        if (host.startsWith('www') || host.startsWith('WWW')) {
            return host.substring(4);
        }
        return host;
    } catch (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            errorMessage: error,
            message: `AigoWebchatv2: failed to get hostname: ERROR: ${error}`,
        });
        return undefined;
    }
};
/**
 * Determine if message is a rich link
 * @param {*} message
 * @param {*} conversationId
 * @returns rich link data
 */
export const isRichLink = (message, conversationId) => {
    if (message?.msgType === 'SERVER' && message?.responseMessage?.type === 2) {
        try {
            const msgResp = JSON.parse(message.responseMessage.o);
            if (msgResp !== undefined && msgResp?.type === 'richLink') {
                return msgResp?.richLinkData;
            }
        } catch (error) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                errorMessage: error,
                message: `AigoWebchatv2: isrichlink - convid: ${conversationId} - ERROR: ${error}`,
                conversationId,
            });
        }
    }
    return null;
};
/**
 *  Utilities for message
 */
export const isReadyMessage = (message) => (message?.msgType === 'SERVER' && message?.responseMessage?.o?.MsgValue === 0);
export const isSelfMessage = (message) => message?.msgType === 'SELF';
export const isServerMessage = (message) => message?.msgType === 'SERVER' && ![7, 11, 10, 2, 12].includes(message?.responseMessage?.o?.MsgValue);
export const isInteractive = (message) => message?.msgType === 'SERVER' && message?.responseMessage?.type === 2;
export const isSurveyLink = (message) => message?.msgType === 'SURVEY';

/**
 * Convert links send in the chat to urls.
 */
export const urlConverter = (message) => {
    if (typeof message !== 'string') return { urlsCount: 0, message: '' };
    let newMessage = message;
    const expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9/][a-zA-Z0-9-/]+[a-zA-Z0-9/]\.[a-zA-Z0-9/?_=&\-~#%]{2,}|www\.^[a-zA-Z0-9/][a-zA-Z0-9-/]+[a-zA-Z0-9/]\.[a-zA-Z0-9/?_=&\-~#%]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9/]+\.[a-zA-Z0-9/?_=&\-~#%]{2,}|www\.[a-zA-Z0-9/]+\.[a-zA-Z0-9/?_=&\-~#%]{2,})/g;
    const urls = message.matchAll(expression);
    const newUrls = [...urls];
    if (newUrls.length) {
        newUrls.forEach((a) => {
            let url = a[0];
            if (!url.match(/^https?:/)) {
                url = `https://${url}`;
            }
            newMessage = newMessage.replace(a[0], `<a href="${url}" target="_blank">${a[0]}</a>`);
        });
    }
    return { urlsCount: newUrls.length, message: newMessage };
};
